<template>
  <section class="text-center mb-20 pt-12">
    <div class="max-w-4xl mx-auto">
      <!-- 标签 -->
      <div class="inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold transition-colors mb-6 bg-psychology-primary-10 text-psychology-primary border-psychology-primary-20">
        <span class="mr-2">🔬</span>
        基于七维度性格模型的趣味测试
      </div>

      <!-- 主标题 -->
      <h1 class="text-5xl md:text-7xl font-bold mb-6 bg-gradient-to-r from-psychology-primary via-psychology-secondary to-psychology-primary bg-clip-text text-transparent">
        动物性格测试
      </h1>

      <!-- 描述 -->
      <p class="text-xl text-gray-600 mb-10 leading-relaxed max-w-3xl mx-auto">
        通过60道精心设计的题目，分析你在支配性、策略性、社群性等七个维度的性格特征，
        为你匹配25种动物原型中最符合你的那一个。
      </p>

      <!-- 主要按钮 -->
      <div class="flex flex-col sm:flex-row gap-4 justify-center items-center mb-14">
        <button
          @click="handleStartAssessment"
          class="btn-primary px-10 py-4 text-lg font-semibold bg-gradient-to-r from-psychology-primary to-psychology-secondary text-white rounded-lg hover:shadow-2xl transition-all inline-flex items-center gap-3"
        >
          <span class="text-2xl">🦊</span>
          <span>开始测试</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
            <path d="M5 12h14"></path>
            <path d="m12 5 7 7-7 7"></path>
          </svg>
        </button>
      </div>

      <!-- 特色数据展示 -->
      <div class="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
        <div class="text-center p-5 bg-white/90 backdrop-blur-sm rounded-2xl border-2 border-psychology-primary-10 shadow-lg hover:shadow-xl transition-all">
          <div class="text-3xl mb-2">⏱️</div>
          <div class="text-2xl font-bold text-psychology-primary">10-15分钟</div>
          <div class="text-sm text-gray-600 mt-1">完成测试</div>
        </div>
        <div class="text-center p-5 bg-white/90 backdrop-blur-sm rounded-2xl border-2 border-yellow-100 shadow-lg hover:shadow-xl transition-all">
          <div class="text-3xl mb-2">📝</div>
          <div class="text-2xl font-bold text-yellow-600">60题</div>
          <div class="text-sm text-gray-600 mt-1">精心设计</div>
        </div>
        <div class="text-center p-5 bg-white/90 backdrop-blur-sm rounded-2xl border-2 border-psychology-primary-10 shadow-lg hover:shadow-xl transition-all">
          <div class="text-3xl mb-2">🎯</div>
          <div class="text-2xl font-bold text-psychology-primary">7维度</div>
          <div class="text-sm text-gray-600 mt-1">性格分析</div>
        </div>
        <div class="text-center p-5 bg-white/90 backdrop-blur-sm rounded-2xl border-2 border-orange-100 shadow-lg hover:shadow-xl transition-all">
          <div class="text-3xl mb-2">🦁</div>
          <div class="text-2xl font-bold text-orange-600">25种</div>
          <div class="text-sm text-gray-600 mt-1">动物原型</div>
        </div>
      </div>

      <!-- 动物展示 -->
      <div class="mt-12 text-7xl animate-bounce-slow">
        🐶 🐱 🐺 🦁 🐻 🦊 🐨 🐯
      </div>
    </div>

    <!-- 激活码验证对话框 -->
    <ActivationCodeDialog 
      :show="showActivationDialog"
      :target-route="targetRoute"
      @close="handleActivationClose"
    />
  </section>
</template>

<script>
import { isActivated } from '@/utils/activationUtils'
import ActivationCodeDialog from './ActivationCodeDialog.vue'

export default {
  name: 'HeroSection',
  components: {
    ActivationCodeDialog
  },
  data() {
    return {
      showActivationDialog: false,
      targetRoute: ''
    }
  },
  methods: {
    handleStartAssessment() {
      // 检查是否已激活
      if (isActivated()) {
        // 已激活，直接跳转
        this.$router.push('/assessment/start')
      } else {
        // 未激活，显示激活码对话框
        this.targetRoute = '/assessment/start'
        this.showActivationDialog = true
      }
    },
    
    handleActivationClose() {
      this.showActivationDialog = false
    }
  }
}
</script>

<style scoped>
.btn-primary:hover {
  transform: translateY(-3px);
}

.btn-primary:active {
  transform: translateY(0);
}

@keyframes bounce-slow {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.animate-bounce-slow {
  animation: bounce-slow 3s ease-in-out infinite;
}
</style>
